module.exports = __webpack_public_path__ + "static/media/AvertaStd-Regular.4cb16aae.woff";